import { generateEndpoint, REMOTE_SUBMISSIONS_BY_TOKEN, } from '../../http/endpoints';
import http from '../../http/http';
export default (() => {
    const create = (token, data) => http.post(generateEndpoint(REMOTE_SUBMISSIONS_BY_TOKEN, { token }), data);
    return {
        create,
    };
})();
